module.exports = __webpack_public_path__ + "img/mobile-rental-assets-06.f6e1b886.png";